import React, { PureComponent } from 'react';

import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import RaisedButton from 'material-ui/RaisedButton';

import Region from './region';
import RegionModalAdd from '../RegionModalAdd';

import styles from 'styles';
import api from 'services';
import { getNormalErrors, showNotification } from 'helpers';

const DWT_GROUPS = {
  'minibulk': '< 10000 minibulker',
  'handysize': '10000 - 34999 handysize',
  'handymax': '35000 - 59999 handymax (supramax)',
  'panamax': '60000 -79999 panamax (new panamax)',
  'capesize': '80000 - 179999 Capesize',
  'verylarge': '180000 - 320000 VLCC (Very Large Crude Carriers)',
  'ultraverylarge': '> 320000 ULCC (Ultra Large Crude Carriers)'
};
const TC_RATES = ['tcRatesDay'];

export default class TimeCharterBulk extends PureComponent {

  state = {
    regions: [],
    isDialogOpened: false,
    unfoldView: localStorage.getItem('unfoldView') ? JSON.parse(localStorage.getItem('unfoldView')) : true
  }

  componentDidMount() {
    this.getRegions();
  }

  getRegions = async () => {
    let result = await api.timeCharters.fetchTimeCharterRegions({type: 'bulk'});

    if (result.status === 200) {
      this.setState({regions: result.data})
    }
  }

  removeRegion = async (id) => {
    let result = await api.timeCharters.removeTimeCharterRegion({_id: id});

    if (result.status === 200) {
      showNotification('Region has been removed');
      return await this.getRegions();
    }

    let errors = getNormalErrors(result);
    showNotification(errors.error, 'error');
  }

  recalculateRegion = async (data) => {
    let result = await api.timeCharters.recalculateTimeCharterRegion(data._id, data);

    if (result.status === 200) {
      showNotification('Region has been recalculated');
      return await this.getRegions();
    }

    let errors = getNormalErrors(result);
    showNotification(errors.error, 'error');
  }

  toggleState = (e, key = 'isDialogOpened') => {
    this.setState({
      [key]: !this.state[key],
    });
  }

  render() {
    let { regions = [], isDialogOpened, unfoldView } = this.state;

    return (
      <div>
        <h4 className='text-center color-common'>Bulk</h4>
        <RaisedButton
          label={`Unfold: ${unfoldView}`}
          primary
          onClick={() => {
            this.toggleState(null, 'unfoldView');
            localStorage.setItem('unfoldView', !unfoldView);
          }}
          style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
          buttonStyle={{ lineHeight: '25px', height: '25px' }}
          labelStyle={{ fontSize: '11px' }}
        />
        <RegionModalAdd
          isDialogOpened={isDialogOpened}
          toggleDialog={this.toggleState}
          getRegions={this.getRegions}
          config={{dwtGroups: DWT_GROUPS}}
          type='bulk'
        />
        <Table selectable={false} className='time-charter-table'>
          <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
            <TableRow style={{borderBottom: '4px solid rgb(224, 224, 224)'}}>
              <TableHeaderColumn style={{...styles.tableHeaderColumnCSS, ...{width: '20%'}}}>
                Region
              </TableHeaderColumn>
              <TableHeaderColumn style={{...styles.tableHeaderColumnCSS, ...{width: '20%'}}}>
                DWT groups (mt)
              </TableHeaderColumn>
              <TableHeaderColumn style={{...styles.tableHeaderColumnSmallCSS, ...{width: '10%'}}}>
                +/-(%) to ww
              </TableHeaderColumn>
              <TableHeaderColumn style={{...styles.tableHeaderColumnSmallCSS, ...{width: '50%'}}} colSpan={4}>
                TCRates by Vessel's type, usd/day
              </TableHeaderColumn>
            </TableRow>
          </TableHeader>

          <TableBody displayRowCheckbox={false}>
            {
              regions.length ?
                regions.map((r, i) => {
                  return (
                    <Region
                      data={r}
                      key={`time-charter-region-${r._id}`}
                      ts={Date.now()}
                      removeRegion={this.removeRegion}
                      recalculateRegion={this.recalculateRegion}
                      getRegions={this.getRegions}
                      dwtGroups={DWT_GROUPS}
                      tcRates={TC_RATES}
                      unfold={unfoldView}
                      type='bulk'
                    />
                  )
                })
              : 'No data'
            }
          </TableBody>
        </Table>
        <div className='m-v-1'>
          <RaisedButton
            label='+ Add'
            primary
            onClick={this.toggleState}
            style={{ margin: '0 10px 0 0', lineHeight: '25px', height: '25px' }}
            buttonStyle={{ lineHeight: '25px', height: '25px' }}
            labelStyle={{ fontSize: '11px' }}
          />
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/components/TimeCharter/Bulk/index.js